import type { SVGProps } from 'react';

const SvgUserFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z'
      fill='currentColor'
    />
    <path d='M20 21C20 17.6829 16.4144 15 12 15C7.58556 15 4 17.6829 4 21' fill='currentColor' />
    <path
      d='M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7ZM20 21C20 17.6829 16.4144 15 12 15C7.58556 15 4 17.6829 4 21H20Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgUserFilled;
